import React from 'react'
import { compose } from 'react-apollo'
import { Form, Modal, Upload, Button } from 'antd'
import { FormattedMessage } from 'react-intl'
const TramsferModal = ({
  bankAccountInfo,
  registration,
  amount,
  visible,
  loading,
  onCheckout,
  onClose,
  form,
  locale
}) => {
  const {
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    validateFields
  } = form
  const beforeUpload = (file, files) => {
    if (file) {
      const fileReader = new FileReader()
      fileReader.onload = e => {
        file.thumbUrl = fileReader.result
        setFieldsValue({
          file
        })
      }
      fileReader.readAsDataURL(file)
      return false
    }
  }
  // TODO: move omise logic near to project root (for easier config import too)
  const fileDecorator = getFieldDecorator('file', {
    rules: [{ required: true, message: 'Please select payment slip' }]
  })
  const file = getFieldValue('file')
  const fileProps = {
    name: 'file',
    action: '',
    beforeUpload,
    fileList: file ? [file] : [],
    showUploadList: false
    // showUploadList: {
    //   showRemoveIcon: false
    // }
  }

  const handleOnSubmit = e => {
    e.preventDefault()
    validateFields((err, formData) => {
      // console.error(err)
      if (!err) {
        e.preventDefault()
        // console.log(formData)
        const { thumbUrl } = formData.file
        const [, mimeType, base64data] = thumbUrl.match(
          /^data:(.+);base64,(.*)$/
        )
        // TODO: send file name
        onCheckout({
          slip: {
            mimeType,
            base64data
          }
        })
      }
    })
  }
  return <Modal visible={visible} footer={null} onCancel={onClose} key="modal">
    <div style={{ fontSize: '16px' }}>
      <div>
        <FormattedMessage id="app.transferRequest.title" />
      </div>
      <ul style={{ margin: '8px', padding: '8px', border: '1px dashed gainsboro' }}>
        <pre>{bankAccountInfo}</pre>
      </ul>
      <div>
        <FormattedMessage id="app.transferRequest.amount" values={{ amount }} />
      </div>
      <div>
        <FormattedMessage id="app.transferRequest.notice" />
      </div>
    </div>
    <Form onSubmit={handleOnSubmit} layout="vertical">
      <Form.Item style={{ textAlign: 'center' }}>
        {fileDecorator(<Upload {...fileProps}>
          <Button style={{ height: 'inherit', padding: '8px' }}>
            {file ? (
              <img
                src={file.thumbUrl}
                style={{ maxWidth: '450px', maxHeight: '450px' }}
                alt=""
              />
            ) : <FormattedMessage id="app.selectAttachment" />
            }
          </Button>
        </Upload>)}
      </Form.Item>
      <Form.Item style={{ textAlign: 'center' }}>
        <Button htmlType="submit" type="primary" loading={loading}>
          <FormattedMessage id="app.submitSlip" />
        </Button>
      </Form.Item>
    </Form>
  </Modal>
}

export default compose(Form.create())(TramsferModal)



// WEBPACK FOOTER //
// ./src/App/components/TransferModal.js